var React = require('react');

function I3 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"I3"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},React.createElement("rect",{"x":"1.67","y":"0.45","width":"22.92","height":"80.01","transform":"translate(-1.68 0.59) rotate(-2.4)","fill":"#f47643","style":{"mixBlendMode":"multiply"}}))]);
}

I3.defaultProps = {"viewBox":"0 0 26.25 80.9"};

module.exports = I3;

I3.default = I3;
